import React from 'react'
import classNames from 'classnames'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

const POSITION_TO_PLACEMENT = {
  'top left': 'top-start',
  'top center': 'top',
  'top right': 'top-end',
  'bottom left': 'bottom-start',
  'bottom center': 'bottom',
  'bottom right': 'bottom-end',
  'left center': 'left',
  'right center': 'right',
}

export const FilterTypePopup = ({ open, setOpen, trigger, children, position, className }) => {
  const placement = POSITION_TO_PLACEMENT[position] || 'bottom-start'

  return (
    <InteractiveTooltip
      clickable
      theme="light"
      placement={placement}
      open={open}
      setOpen={setOpen}
      className={classNames('filter-pill__popup', className)}
      content={open ? children : null}
    >
      {trigger}
    </InteractiveTooltip>
  )
}
